<template>
    <!-- <h2 class="text-2xl text-[#4F3DA5] font-bold mb-3.5">{{ title }}</h2> -->
    <AccordionExtratoPontos :accordions="accordions"/>

</template>
<script>
import AccordionExtratoPontos from "@/Components/UI/Modals/AccordionExtratoPontos.vue"

    export default {
        components: {
            AccordionExtratoPontos
        },
        props: {
            title: String,
            accordions: Object
        }
    }
</script>
